import { useTranslation } from 'react-i18next';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useBrandInfo } from '~/hooks/useBrandInfo';
import ResponsiveActionCardV2 from '~/Nova/scenes/Site/components/ResponsiveActionCardV2';

import { ApiKeysCardProps } from '../utils/types';

const ApiKeysCard = ({ hasLlmAddon, onManageKeys }: ApiKeysCardProps) => {
  const { t } = useTranslation('aiTooling', { keyPrefix: 'apiKeys' });

  const { localizedBrandName } = useBrandInfo();

  return (
    <ResponsiveActionCardV2
      title={t('title')}
      dataTestId="api-keys-card"
      actionButton={
        <Button
          variant="contained"
          fullWidth
          disabled={!hasLlmAddon}
          onClick={onManageKeys}
          data-testid="manage-api-keys-btn"
          sx={{ mt: 2 }}
        >
          {t('manage')}
        </Button>
      }
    >
      <Stack spacing={2}>
        <Typography variant="body2" color="text.secondary">
          {t('description', {
            brand: localizedBrandName,
          })}
        </Typography>

        {!hasLlmAddon && (
          <Alert
            severity="warning"
            data-testid="api-keys-no-addon-message"
            sx={{ p: 0 }}
          >
            {t('noCredits')}
          </Alert>
        )}
      </Stack>
    </ResponsiveActionCardV2>
  );
};

export default ApiKeysCard;
